import {
  CLOSEDMANUALOTPREQUESTLIST_SUCCESS,
  CLOSEDMANUALOTPREQUESTLIST_FAILED,
  RESET_CLOSEDMANUALOTPREQUESTLIST,
  LOADING_CLOSEDMANUALOTPREQUESTLIST,
  NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CLOSEDMANUALOTPREQUESTLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case CLOSEDMANUALOTPREQUESTLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case CLOSEDMANUALOTPREQUESTLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_CLOSEDMANUALOTPREQUESTLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_CLOSEDMANUALOTPREQUESTLIST:
      return (state = initialState);
    default:
      return state;
  }
};
